import { formatInTimeZone } from 'date-fns-tz'
import { cohortDateToUtc } from '../enrollment/getEnrollmentState'
import type { CohortConfig, CohortDate } from '../types'

export const formatCohortDate = (
  date: CohortDate,
  timezone: CohortConfig['timezone'],
): string =>
  formatInTimeZone(cohortDateToUtc(date, timezone), timezone, 'MMM d')

/** `deadline` is the exclusive window end, so the last enrollment day is the day before. */
export const formatEnrollmentDeadline = (
  deadline: string,
  timezone: CohortConfig['timezone'],
): string =>
  formatInTimeZone(new Date(Date.parse(deadline) - 1), timezone, 'MMM d, yyyy')
